import React, { Component } from 'react';
import { Row, Col, Clearfix, Button } from 'react-bootstrap';
import FormOverlay from '../../../../components/FormOverlay';
import FieldGroup from '../../../../components/FieldGroup';
import Icon from '../../../../components/Icon';
import { handleFieldChange } from "../../../../Utils";


class Form extends Component {
    constructor(props) {
        super(props);

        if(props.offer) this.state = this.getOfferData(props.offer);
        else {
            this.state = {
                title: '',
                body: '',
                icon: '',
                image: '',
                url: '',
                btn1Title: '',
                btn1Icon: '',
                btn2Title: '',
                btn2Icon: ''
            }
        }


        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    getOfferData(offer) {
        const params = [ 'id', 'title', 'body', 'icon', 'image', 'url', 'btn1Title', 'btn1Icon', 'btn2Title', 'btn2Icon' ];

        return params.reduce((obj, param) => {
            if(offer[param]) obj[param] = offer[param];
            else obj[param] = '';

            return obj;
        }, {});
    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.onSubmit(this.state);
    }

    render() {
        return (
            <FormOverlay onFormHide={this.props.onFormHide}>
                <form onSubmit={this.handleSubmit}>
                    <FieldGroup
                        name="title"
                        label="Title:"
                        onChange={this.handleFieldChange}
                        value={this.state.title}
                        required
                    />
                    <FieldGroup
                        name="body"
                        label="Body:"
                        onChange={this.handleFieldChange}
                        value={this.state.body}
                        required
                    />
                    <FieldGroup
                        name="icon"
                        label="Icon:"
                        onChange={this.handleFieldChange}
                        value={this.state.icon}
                        required
                    />
                    <FieldGroup
                        name="image"
                        label="Image:"
                        onChange={this.handleFieldChange}
                        value={this.state.image}
                    />
                    <FieldGroup
                        name="url"
                        label="URL:"
                        onChange={this.handleFieldChange}
                        value={this.state.url}
                        required
                    />
                    <Row>
                        <Col lg={6}>
                            <FieldGroup
                                name="btn1Title"
                                label="Button1 Title:"
                                onChange={this.handleFieldChange}
                                value={this.state.btn1Title}

                            />
                        </Col>
                        <Col lg={6}>
                            <FieldGroup
                                name="btn1Icon"
                                label="Button1 Icon:"
                                onChange={this.handleFieldChange}
                                value={this.state.btn1Icon}

                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={6}>
                            <FieldGroup
                                name="btn2Title"
                                label="Button2 Title:"
                                onChange={this.handleFieldChange}
                                value={this.state.btn2Title}
                            />
                        </Col>
                        <Col lg={6}>
                            <FieldGroup
                                name="btn2Icon"
                                label="Button2 Icon:"
                                onChange={this.handleFieldChange}
                                value={this.state.btn2Icon}
                            />
                        </Col>
                    </Row>
                    <Clearfix>
                        <Button className="pull-right" bsStyle="success" type="submit"><Icon name="floppy-o"/> Save</Button>
                    </Clearfix>
                </form>
            </FormOverlay>
        );
    }
}

export default Form;


// WEBPACK FOOTER //
// ./src/scenes/Dating/components/Form/index.js